import { toast } from "react-toastify";
import { FILE_UPLOAD } from "../services/ApiCalls";

export default async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const res = await FILE_UPLOAD(formData);
    if (res?.data?.status === "success") {
      return res?.data?.data?.url;
    } else {
      toast.error(res.data.message);
      return false;
    }
  } catch (error) { 
    toast.error("Something went wrong while uploading image");
    console.log(error);
  }
};
